import axios from 'axios';
import { DHLError, handleHttpResponse, axiosRequest, isSuccessfulResponse } from '@general/js/utils';
import Services from '@general/js/services/Services';
import AbstractClass from './MembershipStatusAbstractServices';

export default class MembershipStatusServices extends AbstractClass {
  /**
   * Implicitly returns a Promise for fetching Membership Status reference data
   */
  static async getReferenceData() {
    try {
      const response = await axios.get(Services.MEMBERSHIP_STATUS.GET_REFERENCE_DATA);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getReferenceData() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Implicitly returns a Promise for fetching prorata price.
   * @param {string} memberNumber member number or policy number
   * @param {object} payload contains params object necessary for sending payload
   *                          payload will differ based on where it is called from (CreateMembership vs PremiumCalculator)
   */
  static async getProrataPrice(memberNumber, payload) {
    try {
      const response = await axiosRequest().get(Services.MEMBERSHIP_STATUS.GET_PRORATA_PRICE(memberNumber), payload);
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getProrataPrice() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * This API will return the premium adjustment to the account after updating to a specified policy.
   * @param {string} memberNumber member number or policy number
   * @param {object} showPremiumPaymentAmount determines whether the premium payment is skipped.
   * @param {string} coverStartDate cover start date
   * @param {object} startDateCatchUp the start date for catch up calculation.
   */
  static async getPremiumAdjustments(memberNumber, showPremiumPaymentAmount, coverStartDate, startDateCatchUp) {
    try {
      const response = await axiosRequest().get(Services.MEMBERSHIP_STATUS.GET_PREMIUM_ADJUSTMENTS(memberNumber, showPremiumPaymentAmount, coverStartDate, startDateCatchUp));
      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getPremiumAdjustments() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  /**
   * Implicitly returns a Promise for submitting an immediate payment request to OHI.
   */
  static async submitImmediatePaymentRequest(memberNumber, payload) {
    try {
      const response = await axiosRequest().post(`${Services.MEMBERSHIP_STATUS.SUBMIT_PAYMENT_REQUEST(memberNumber)}`, payload);
      if (isSuccessfulResponse(response)) {
        return response;
      }
      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`payNow() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
